function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { memo, useCallback, useMemo, useState } from 'react';
import { StyleSheet } from 'react-native';
import { Box, Divider, HStack, Hidden, Pressable, VStack } from 'native-base';
import { Iconography, Typography, logUserEvent } from 'fmc-digital-common';
import SelectedFileRow from '../SelectedFileRow';
import { useLipStore } from '../../../loaninprogress';
import { Functions } from '../../../utils';
import { DocUploadSnackbar } from '../DocUploadSnackbar';
const styles = StyleSheet.create({
  inputFileUpload: {
    display: 'none'
  },
  formInput: {
    pointerEvents: 'none'
  }
});
const DocUploadBody = ({
  taskName
}) => {
  const {
    files: fileData,
    setSelectedFiles,
    isDocUploading,
    setErrorMessages,
    errorMessages,
    clearErrorMessages
  } = useLipStore(state => state);
  const [enterDrop, setEnterDrop] = useState(false);
  const inputRef = React.useRef(null);
  const manageUploadFiles = useCallback(files => {
    if (errorMessages && errorMessages.length) clearErrorMessages('NoFile');
    const {
      fileInfo,
      errors
    } = Functions.validateFiles(files);
    setSelectedFiles(fileInfo);
    setErrorMessages(errors);
  }, [errorMessages, clearErrorMessages, setSelectedFiles, setErrorMessages]);
  const handleDrop = useCallback(e => {
    e.preventDefault();
    e.stopPropagation();
    setEnterDrop(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length) {
      manageUploadFiles(e.dataTransfer.files);
      logUserEvent({
        action: 'FileDraggedDropped',
        type: 'LIPDocUploadPopUp',
        description: `Task Section Doc Upload Task ${taskName}`
      });
    }
  }, [manageUploadFiles, taskName]);
  const handleDrag = e => {
    e.preventDefault();
    e.stopPropagation();
    setEnterDrop(e.type === 'dragover');
  };
  const onHandleBrowse = e => {
    e.preventDefault();
    e.stopPropagation();
    if (e.target.files && e.target.files.length) {
      manageUploadFiles(e.target.files);
    }
  };
  const selectFile = useMemo(() => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Pressable, {
      marginY: '2',
      paddingY: '1.5',
      testID: "selectFile",
      disabled: isDocUploading,
      onPress: () => {
        logUserEvent({
          action: 'SelectFileClicked',
          type: 'LIPDocUploadPopUp',
          description: `Task Section Doc Upload Task ${taskName}`
        });
        if (inputRef && inputRef.current) {
          //@ts-ignore
          inputRef.current.click();
        }
      }
    }, /*#__PURE__*/React.createElement(HStack, {
      space: '2'
    }, /*#__PURE__*/React.createElement(Box, {
      alignSelf: 'center'
    }, /*#__PURE__*/React.createElement(Iconography, {
      name: "search",
      size: 20,
      color: "blue.900"
    })), /*#__PURE__*/React.createElement(Typography, {
      alignSelf: 'center',
      variant: 'regularBold',
      color: 'blue.900',
      accessibilityRole: "text",
      accessibilityLabel: "select file"
    }, "SELECT FILE"))), /*#__PURE__*/React.createElement(Typography, {
      variant: 'caption13',
      textAlign: 'center',
      color: 'review.500'
    }, `Accepted file formats: .PDF, .JPEG, .JPG, .PNG. Max file size \n for one file upload is 8 MB. You can upload 10 files at a time.`));
  }, [taskName, isDocUploading]);
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Box, {
    marginBottom: 2
  }, /*#__PURE__*/React.createElement(Hidden, {
    from: "lg",
    platform: ['ios', 'android']
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: e => e.preventDefault()
  }, /*#__PURE__*/React.createElement("input", {
    ref: inputRef,
    type: "file",
    multiple: true,
    onChange: onHandleBrowse,
    style: styles.inputFileUpload
  }), /*#__PURE__*/React.createElement(VStack, {
    padding: 4,
    borderRadius: 4,
    backgroundColor: enterDrop ? 'lightBlue.400' : 'white.800',
    borderWidth: 2,
    borderColor: enterDrop ? 'review.500' : '#A1ACC0',
    borderStyle: 'dashed',
    alignItems: 'center'
  }, selectFile))), /*#__PURE__*/React.createElement(Hidden, {
    till: "lg",
    platform: ['ios', 'android']
  }, /*#__PURE__*/React.createElement("form", {
    onDragOver: handleDrag,
    onDragLeave: handleDrag,
    onDrop: handleDrop,
    onSubmit: e => e.preventDefault(),
    style: isDocUploading ? styles.formInput : undefined
  }, /*#__PURE__*/React.createElement("input", {
    ref: inputRef,
    type: "file",
    multiple: true,
    onChange: onHandleBrowse,
    style: styles.inputFileUpload
  }), /*#__PURE__*/React.createElement(VStack, {
    padding: 4,
    borderRadius: 4,
    backgroundColor: enterDrop ? 'lightBlue.400' : 'white.800',
    borderWidth: 2,
    borderColor: enterDrop ? 'review.500' : '#A1ACC0',
    borderStyle: 'dashed',
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(HStack, null, /*#__PURE__*/React.createElement(Typography, {
    variant: 'regularBold',
    color: 'black',
    accessibilityRole: "text",
    accessibilityLabel: "Drag and Drop"
  }, "Drag and Drop"), /*#__PURE__*/React.createElement(Typography, {
    variant: 'regular',
    color: 'darkGray.900',
    marginLeft: 1,
    accessibilityRole: "text",
    accessibilityLabel: "your files here"
  }, "your files here or")), selectFile)))), errorMessages && errorMessages.length ? errorMessages.map((error, index) => /*#__PURE__*/React.createElement(DocUploadSnackbar, _extends({
    key: index
  }, error))) : null, /*#__PURE__*/React.createElement(Divider, {
    mt: 1,
    height: 0
  }), fileData.map((item, index) => /*#__PURE__*/React.createElement(SelectedFileRow, {
    key: index,
    file: item,
    index: index,
    url: URL.createObjectURL(item)
  })));
};
export default /*#__PURE__*/memo(DocUploadBody);
//# sourceMappingURL=index.js.map